import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/(organization)/_layout/tasks')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello /_authed/(organization)/_layout/tasks!</div>;
}
